module.exports = __webpack_public_path__ + "img/fellowship-white.bca967ab.svg";